import { DISPPLAY_MOMENT_YMD_HM, ekDomain, MY_ACCOUNT_PATH, ORDER_STATUS_CMS, ROUTES } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import OrderTimeLine from '@/pages/reservation-cms/detail/components/OrderTimeLine';
import { isPathEk } from '@/utils/routes';
import { observer } from 'mobx-react-lite';
import { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BookingInfor from '@/pages/reservation-cms/detail/components/BookingInfor';
import PaymentInfor from '@/pages/reservation-cms/detail/components/PaymentInfor';
import { CalenderIcon } from '@/components/icon/Calender';
import { formatDateTime } from '@/utils/datetime';
import classNames from 'classnames';
import AnimateButton from '@/components/general/button-custom/AnimateButton';

export default observer(function RevenueDetail() {
    // hooks
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    // store
    const { reservationStore: { reservationEND, getReservationENDDetail, getPaymentHistory, paymentHistory } } = useStore();

    // lifecycle
    useEffect(() => {
        if (id) {
            getReservationENDDetail(+id);
            getPaymentHistory({ id });
        }
    }, [id]);

    // functions
    const handleClickBack = () => {
        navigate(isPathEk(pathname) ? `/${ekDomain}/${ROUTES.myAccount.hrefEK}/${MY_ACCOUNT_PATH.rentalHistory}` : `${ROUTES.myAccount.href}/${MY_ACCOUNT_PATH.rentalHistory}`);
    };

    return (
        <Suspense fallback={<div>{t('words_title.loading')}</div>}>
            <div className='relative'>
                <div className='flex flex-col gap-4 max-w-full'>
                    <div className='flex gap-2 point-600:flex-row flex-col items-start justify-between relative'>
                        <div className='text-fs-mid18 point-600:flex flex-col gap-2 hidden point-600:order-1 order-2'>
                            <div className='flex gap-2 items-center flex-wrap relative'>
                                <p className=''>
                                    <label className='font-semibold'>
                                        {t('field.reservation.reservation_code')}
                                        :
                                        {' '}
                                    </label>
                                    <span className='font-medium'>{reservationEND?.information?.orderCodeSystem}</span>
                                </p>
                                {reservationEND?.information?.orderStatus != null ?
                                    (
                                        <div className={classNames(`${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.color} ${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.bgColor} border ${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.border} font-normal px-3 h-6 flex items-center text-[1rem] rounded-[0.25rem]`, 'font-medium')}>
                                            {t(`${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.key}`)}
                                        </div>
                                    ) :
                                    <p>--</p>}

                            </div>
                            <div className='flex gap-1 items-end'>
                                <label className=''>
                                    <CalenderIcon />
                                </label>
                                <span className='font-normal leading-[1] text-black-1'>{reservationEND?.information?.orderDate && formatDateTime(reservationEND?.information?.orderDate, DISPPLAY_MOMENT_YMD_HM, { useLocalTime: false })}</span>
                            </div>
                        </div>
                        <AnimateButton
                            type='button'
                            outline
                            side='left'
                            contentComp={t('button.back_to_screen')}
                            parentClassName='h-[44px] point-600:w-fit w-full point-600:order-2 order-1 flex gap-1'
                            className=' px-3 rounded-button'
                            textClassName='!text-[14px] !pl-6.5'
                            iconArrowClassName='size-[15px]'
                            onClick={handleClickBack}
                        />

                    </div>
                    <div className='grid point-940:grid-cols-3 gap-4 md:gap-6 max-w-full'>
                        <div className='bg-background-3 rounded-base point-940:col-span-2 col-span-full max-w-full overflow-hidden'>
                            <div className={classNames(
                                'p-4 rounded-t-base point-600:hidden flex justify-between gap-1 text-white items-center',
                                `${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.bgLinear}`
                            )}
                            >
                                <p className='flex flex-col gap-1'>
                                    <label className='text-fs-mid14'>
                                        {t('field.reservation.reservation_code')}
                                    </label>
                                    <span className='font-semibold text-fs-mid16'>{reservationEND?.information?.orderCodeSystem}</span>
                                </p>
                                {reservationEND?.information?.orderStatus != null ?
                                    (
                                        <div className={classNames('bg-[#FFFFFF33] font-semibold px-3 py-1 h-6 flex items-center text-fs-mid14 rounded-[0.25rem]')}>
                                            {t(`${ORDER_STATUS_CMS[reservationEND?.information?.orderStatus]?.key}`)}
                                        </div>
                                    ) :
                                    <p>--</p>}
                            </div>
                            <div className='flex gap-1 items-end text-fs-mid16 point-600:hidden p-4 pb-0'>
                                <label className=''>
                                    <CalenderIcon width={19} />
                                </label>
                                <span className='font-normal leading-[1] text-black-1'>{reservationEND?.information?.orderDate && formatDateTime(reservationEND?.information?.orderDate, DISPPLAY_MOMENT_YMD_HM, { useLocalTime: false })}</span>
                            </div>
                            <BookingInfor reservation={reservationEND || {}} isForEND={true} />
                        </div>
                        <div className='layout-card  col-span-full point-940:col-span-1'>
                            <OrderTimeLine
                                historyTime={reservationEND?.information?.historyTime || {}}
                                orderStatus={reservationEND?.information?.orderStatus}
                                isEnduser={true}
                                paymentHistory={paymentHistory}
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-3 gap-6'>
                        <div className='col-span-full flex flex-col gap-4 md:gap-6'>
                            <div className='layout-card'>
                                <PaymentInfor reservation={reservationEND} isForEnd={true} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Suspense>
    );
});
